import './image-gallery.scss';
import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';

import Flickity from 'react-flickity-component';

export default function ImageGallery({ images, title, onFullScreenImageGalleryOpen }) {
	const [refFlickity, setFlickityRef] = useState(null);

	function onClick(event) {
		event.preventDefault();
		event.stopPropagation();
	}

	function getImageTypes(images) {
		return images.filter((image, index, origImages) => index === origImages.findIndex(imageToFind => imageToFind.type === image.type));
	}

	useEffect(() => {
		if (refFlickity) {
			refFlickity.on('staticClick', () => {
				onFullScreenImageGalleryOpen(refFlickity.selectedIndex, images);
			});
		}
	}, [refFlickity, images]);

	useEffect(() => {
		if (refFlickity) {
			refFlickity.select(0, false, true);
		}
	}, [images]);

	return (
		<div class={'plot-modal-image-gallery-container ' + (getImageTypes(images).map(image => 'contains-type-' + image.type ).join(' '))}>
			{title ?
				<h3 class="plot-modal-image-gallery-header plot-section-header">{title}</h3> : ''}
			<Flickity
				className={'images-count-' + images.length}
				flickityRef={setFlickityRef}
				options={{
					pageDots: false,
					selectedAttraction: 0.2,
					friction: 0.8
				}}
			>
				{images.map(image => (
					<a class={`image-gallery-image-container image-gallery-image-id-${image.id} image-gallery-image-type-${image.type}`} href={image.src} onClick={onClick}>
						<img src={image.src} width={image.width} height={image.height} />
					</a>
				))}
			</Flickity>
		</div>
	);
}
